/* eslint-disable camelcase */
import Mitt from 'mitt';

/**
 * 对接知识库问答的WebSocket类
 */
export default class KnowledgeChatSocket {
    get connected () {
        return this.socket && this.socket.readyState === 1;
    }

    constructor (options) {
        let { sessionId } = options || {};
        this.sessionId = sessionId = sessionId || Date.now();
        // 挂接事件处理函数
        let emitter = Mitt();
        this.$emit = emitter.emit;
        this.$on = emitter.on;
        this.$once = emitter.once;
        this.$off = emitter.off;

        this.tempStr = ''; // 临时存储字符串

        // 创建WebSocket连接
        let { protocol, host } = window.location;
        let url = `${protocol === 'https:' ? 'wss' : 'ws'}://${host}/llm/knowledge-chat/${sessionId}`;
        this.socket = new WebSocket(url); // 使用您的实际WebSocket服务器地址
        // 连接打开时的处理函数
        this.socket.onopen = (event) => {
            this.$emit('open', event);
        };

        let tempStr = ''; // 临时存储字符串
        let typingTimeoutObj = null;
        // 接收消息时的处理函数
        this.socket.onmessage = async (event) => {
            if (event.type === 'message') {
                let message = event.data;
                if (message === 'CONNECT_SUCCESS') {
                    console.info(message);
                    this.$emit('connected');
                    return;
                } else if (message === '此连接已建立,请勿重复建立') {
                    console.error(message);
                    // this.close();
                    this.$emit('error', new Error(message));
                    return;
                } else if (message === 'BYE!') {
                    console.warn(message);
                    return;
                } else if (message === 'pong') {
                    console.info('WS心跳', new Date().toLocaleString());
                    return;
                }

                // 强制转为JSON
                message = JSON.parse(message);

                this.$emit('message', message);

                // 设置3秒超时，强制打字完成
                clearTimeout(typingTimeoutObj);
                typingTimeoutObj = setTimeout(async () => {
                    let ret = tempStr;
                    tempStr = '';

                    /**
                     * @event done
                     * 消息接收完成事件
                     */
                    this.$emit('done', ret);
                }, 3000);

                // 文字回答
                if (message && message.type === 'TEXT') {
                    if (message.status === 'FINISH') {
                        let ret = tempStr;
                        tempStr = '';

                        /**
                         * @event done
                         * 消息接收完成事件
                         */
                        this.$emit('done', ret);
                    } else {
                        tempStr += message.answer;
                    }
                }
            }
        };

        // 连接关闭时的处理函数
        this.socket.onclose = (event) => {
            console.info('已断开连接');
            this.$emit('close', event);
        };

        // 连接出错时的处理函数
        this.socket.onerror = (event) => {
            console.error('出现错误', event);
            this.$emit('error', event);
        };
    }

    send (message) {
        if (typeof (message) === 'string') {
            // 本来是字符串就不强制转JSON
        } else {
            message = JSON.stringify(message);
        }
        this.socket.send(message);
    }

    close () {
        this.socket.close();
    }
}
